import ScreenWrapper from "@/components/ScreenWrapper"
import CreateHolidayForm from "@/components/forms/holidays/CreateHolidayForm"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/feestdagen/aanmaken/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "holidays"),
})

function RouteComponent() {
  return (
    <ScreenWrapper showManagementMenu>
      <CreateHolidayForm />
    </ScreenWrapper>
  )
}
